export const MAX_DISTANCE_FROM_ORIGINAL_OFFER_KM_ALL_REGIONS = 6;

export const MAX_DISTANCE_FROM_ORIGINAL_OFFER_KM_WARSAW = 4;
export const MAX_DISTANCE_FROM_ORIGINAL_OFFER_KM_ALL_REGIONS = 6;

export const MAX_DISTANCE_FROM_ORIGINAL_OFFER_KM_WARSAW = 4;
